<template>
  <VCard class="payment-giftcard-wrapper">
    <VBlock class="payment-giftcard" :sort="Sort.space_between">
      <VSpan text="상품권" :size="16" :spacing="-0.35" :color="TextColor.darkGray" />
      <VA :onClick="onOpenGiftCardModal" class="giftcard-button">
        <VSpan
          v-show="false"
          class="detail"
          :type="TextType.Number"
          :text="`원 사용`"
          :size="14"
          :spacing="-0.35"
          :color="TextColor.gray"
        />
        <VBlock>
          <VSpan
            v-show="true"
            class="detail"
            :text="
              selectedGiftCardsExist
                ? `- ${selectedGiftCardsPrice}원`
                : `${giftCards.length}개 보유`
            "
            :size="14"
            :spacing="-0.35"
            :color="TextColor.gray2"
          />
          <div class="image-wrapper">
            <img :src="resources.foldIcon" :style="{ transform: 'rotate(-90deg)' }" />
          </div>
          <!-- </dlv> -->
        </VBlock>
      </VA>
    </VBlock>
  </VCard>
</template>

<script>
import foldIcon from '@/assets/images/fold-icon.svg'
import VBlock, { Direction, Sort } from '../../molecules/VBlock/index'
import VSpan, { TextColor, TextType } from '../../atoms/VSpan/index'
import VA from '../../molecules/VA/index'
import VCard, { ColorType } from '../../molecules/VCard/index'

export default {
  name: 'PreOrderPaymentGiftCard',
  components: { VA, VSpan, VBlock, VCard },
  props: {
    onOpenGiftCardModal: {
      type: Function,
      required: true
    },
    giftCards: {
      type: Array
    }
  },
  computed: {
    selectedGiftCardsExist() {
      return this.$store.getters['preOrder/selectedGiftCards'].length > 0
    },
    selectedGiftCardsPrice() {
      return this.$store.getters['preOrder/selectedGiftCards']
        .reduce((prev, next) => prev + next.spentAmount, 0)
        .toLocaleString()
    }
  },
  data() {
    return {
      Direction,
      Sort,
      TextColor,
      TextType,
      ColorType,

      resources: {
        foldIcon
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.payment-giftcard-wrapper {
  width: 100%;
  height: 60px;
  border-bottom: 1px solid $light-gray-8;

  .payment-giftcard {
    width: 100%;
    height: auto;
    box-sizing: border-box;
    padding: 21px 15px 19px;
    align-items: center;

    .giftcard-button {
      display: flex;
      justify-content: center;
      align-items: center;
      .image-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 22px;
        padding-bottom: 1px;
      }
    }

    .detail {
      margin-right: 4px;
      vertical-align: middle;
    }
  }
}
</style>
